import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import NetActions, { NetRedux, NetTypes } from '../Redux/NetRedux'
import { notificationFail } from '../Redux/NotificationActions'

const netCrudObservable = createCRUDObservable({
  mainRedux: NetRedux,
  reduxPath: 'net',
})

const netExcelEpic = (action$, store, { Api }) =>
  action$.ofType(NetTypes.NetExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.net.getNetExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            NetActions.NetExcelSuccess(),
          ]
        })
    ))

export const netObservers = Object.assign({}, netCrudObservable.observers, {})

export const netEpic = combineEpics(
  netCrudObservable.epic,
  netExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/NetObservable.js